import { render } from "./RKLRPL.vue?vue&type=template&id=22d7bb26"
import script from "./RKLRPL.vue?vue&type=script&lang=js"
export * from "./RKLRPL.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__